import { useState, useCallback, useEffect, useRef } from 'react';
import { IGroupSelectPropsType, ISelectOptionItemType } from '../type';

const useFilterData = (props: IGroupSelectPropsType) => {
  const { value: valueProps, defaultValue, onOpen, onClose, onChange } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [internalValue, setInternalValue] = useState(defaultValue || ''); // 非受控模式内部状态值
  const [isControlled, setIsControlled] = useState(false); // 是否为受控模式
  const initRef = useRef(false); // 是否初始态，用于有defaultSearchValue但autoClearSearchValue为true

  useEffect(() => {
    if (isControlled || typeof valueProps !== 'undefined') {
      setIsControlled(true);
    }
  }, [valueProps]);

  // Options选择change事件
  const handleSelectChange = useCallback(
    (
      val: string,
      context?: {
        event: React.SyntheticEvent<Element, Event>;
        option?: ISelectOptionItemType[];
      },
    ) => {
      if (isControlled) {
        setInternalValue(val);
      }
      onChange?.(val, context);
      handleClose();
    },
    [onChange, isControlled],
  );

  // clear all事件
  const handleClearAll = useCallback(() => {
    if (isControlled) {
      setInternalValue('');
    }
    handleSelectChange('');
    onChange?.('', undefined);
  }, [onchange, isControlled, handleSelectChange]);

  // 打开下拉框
  const handleOpen = () => {
    setIsOpen(true);
    onOpen?.();
  };

  // 关闭下拉框
  const handleClose = () => {
    if (!initRef.current) {
      initRef.current = true;
    }
    setIsOpen(false);
    onClose?.();
  };

  return {
    optionsValue: isControlled ? valueProps || '' : internalValue,
    handleSelectChange,
    handleClearAll,
    handleOpen,
    handleClose,
    isOpen,
    isInit: initRef.current,
  };
};

export default useFilterData;
